var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M3.333 2.667H6L7.333 6 5.667 7A7.33 7.33 0 0 0 9 10.333l1-1.666L13.333 10v2.667A1.333 1.333 0 0 1 12 14 10.667 10.667 0 0 1 2 4a1.333 1.333 0 0 1 1.333-1.333M10 4.667A1.333 1.333 0 0 1 11.333 6M10 2a4 4 0 0 1 4 4"
  })));
};
export default SvgPhone;